import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "flowbite-react/components/Modal";
import { ReactNode, useMemo } from "react";
import { Button } from "../Button/Button";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils";

type TCommonModalProps = {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
  title: string | ReactNode;
  size: string;
  buttonCancel?: () => void;
  buttonAccept?: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmButtonProps?: any;
  cancelButtonProps?: any;
  type: string;
  contentProps?: any;
  classNameModal?: string;
  spinnerHtml?: ReactNode;
  id?: string;
  dataTestId?: string;
};

const CommonModalUI = ({
  open,
  onClose,
  children,
  title,
  size,
  buttonCancel,
  buttonAccept,
  cancelText,
  confirmText,
  confirmButtonProps,
  cancelButtonProps,
  type,
  contentProps,
  classNameModal,
  spinnerHtml,
  id,
  dataTestId,
}: TCommonModalProps) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const dialogContent = useMemo(() => {
    return (
      <>
        <ModalHeader className="p-3 modal-title modal-header">
          {type === "delete" ? "Confirm Delete" : title}
        </ModalHeader>

        <ModalBody className="modal-body p-3" {...contentProps}>
          {children ?? title}
        </ModalBody>
        {(buttonCancel ?? buttonAccept) && (
          <ModalFooter
            className={cn("p-3", isRTL ? "justify-start" : "justify-end")}
          >
            {buttonCancel && (
              <Button
                variant="outline"
                size="sm"
                className="button-min-width"
                {...cancelButtonProps}
                onClick={buttonCancel}
                id={`${id}-cancel-button`}
              >
                {cancelText}
              </Button>
            )}
            {buttonAccept && (
              <Button
                variant="default"
                size="sm"
                className="button-min-width"
                {...confirmButtonProps}
                onClick={buttonAccept}
                id={`${id}-confirm-button`}
              >
                {confirmText} {spinnerHtml}
              </Button>
            )}
          </ModalFooter>
        )}
      </>
    );
  }, [
    type,
    title,
    isRTL,
    contentProps,
    children,
    buttonCancel,
    buttonAccept,
    cancelButtonProps,
    cancelText,
    confirmButtonProps,
    confirmText,
    spinnerHtml,
    id,
  ]);

  return (
    <Modal
      show={open}
      onClose={onClose}
      size={size}
      // className={classNameModal}
      data-testid={dataTestId}
      className={`custom-modal-overlay ${classNameModal ?? ""}`}
    >
      {dialogContent}
    </Modal>
  );
};

export default CommonModalUI;
